// Central place to update the company's contact details.
// Update these values and the whole site updates with them.

export const COMPANY_NAME = "Jia Cheng Cleaning & Renovation";
export const WHATSAPP_NUMBER = "601133092064"; // no + or spaces, used for wa.me links
export const WHATSAPP_DISPLAY = "+60 11-3309 2064";
export const EMAIL = "jiachen852@gmail.com";
export const WHATSAPP_DEFAULT_MESSAGE =
  "Hi Jia Cheng Cleaning & Renovation, I'd like to ask about a service.";

export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  WHATSAPP_DEFAULT_MESSAGE
)}`;
export const CALL_LINK = `tel:+${WHATSAPP_NUMBER}`;
export const MAIL_LINK = `mailto:${EMAIL}`;
